import Categories from '../marinetools/components/selftest/containers/Categories.jsx';

export default function Home() {
  return (
    <section className="as-section as-hero-section">
      <div className="container">
        <div className="text-center mb-4">
          <h1 className="as-page-title">Nautical Knowledge Self Test</h1>
          <p className="as-lead mx-auto" style={{ maxWidth: 640 }}>
            Test your marine knowledge. Select category you would like to test yourself in,
            view the questions and visual image, decide on the action you would take and
            click the image to see the answer. Click the buttons under answer to keep score
            and move to next question in category.
          </p>
        </div>

        <Categories />
      </div>
    </section>
  );
}
